var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResponseicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2890_4298)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2890_4298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.64905 9.70532H5.00024V14.3538H9.64905V9.70532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9992 7.55061V14.3523H14.2974V12.251C14.2974 10.8435 13.1555 9.70165 11.7473 9.70165H9.64636V5.00073H16.4491C17.8573 5.00073 18.9992 6.14254 18.9992 7.55061Z",
    fill: "#00E2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2978 14.3486V18.9971L9.64899 14.3486H14.2978Z",
    fill: "#00E2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2974 12.252V14.3533L9.64636 9.70264H11.7473C13.1555 9.70264 14.2968 10.8439 14.2968 12.252",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2890_4298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9412,
    height: 16.9412,
    fill: "white",
    transform: "translate(20.4708 3.52954) rotate(90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2890_4298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5.00024 5.00024)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponseicon);
export default __webpack_public_path__ + "static/media/responseicon.7b880c4ff08aecb55ee90f020c747d4a.svg";
export { ForwardRef as ReactComponent };